export default __webpack_public_path__ + "static/media/bottom-left-ellipse.cb6108b1.svg";